<template>
  <div
    v-if="!route.meta.isDesktop"
    class="page main_container"
  >
    <div class="grow" />

    <div class="central-image-wrapper">
      <img
        width="278"
        height="296"
        style="margin-top: 24px;flex-shrink: 0"
        src="@/assets/images/system/new_version_available.png"
      />
      <Logo
        class="project-logo"
        fit
      />
    </div>

    <Typography
      variant="subtitle"
      style="margin-bottom: 8px; margin-top: 32px"
      center
    >
      Ура! У нас вышла новая версия платформы!
    </Typography>

    <Typography
      variant="body1"
      center
    >
      Обновление происходит мгновенно — просто нажми на <span
        style="font-weight: 700"
      >«Обновить»</span>
    </Typography>

    <div class="grow" />

    <AppButton
      full-width
      style="margin-top: 24px"
      :loading="isRefreshing"
      @click="refresh"
    >
      Обновить
    </AppButton>
  </div>
</template>

<script setup>
import { computed, onBeforeMount } from 'vue'
import { useRoute } from 'vue-router'

import store from '@/store/store.js'

import AppButton from '@/components/UI/AppButton.vue'
import Logo from '@/components/UI/Logo.vue'
import Typography from '@/components/UI/Typography.vue'

const route = useRoute()

const isRefreshing = computed(() => store.state.app.isVersionRefreshing)

onBeforeMount(() => {
  if (route.meta.isDesktop) {
    void refresh()
  }
})

async function refresh() {
  await store.dispatch('app/setIsVersionRefreshing', true)

  try {
    const registrations = await navigator.serviceWorker.getRegistrations()
    for (const registration of registrations) {
      await registration.unregister()
    }
  } catch (error) {
    console.log('e', error)
  } finally {
    window.location.reload(true)
  }
}
</script>

<style lang="scss" scoped>
.page {
  min-height: 100svh;
  max-height: 100svh;
  display: flex;
  flex-direction: column;
  overflow: auto;
  align-items: center;
  padding: 36px;

  .central-image-wrapper {
    position: relative;
    .project-logo {
      position: absolute;
      top: calc(50% - 2px);;
      left: calc(50% + 32px);
      transform: translate(-50%, -50%);

      width: 98px;
      height: 27px;
    }
  }
}

.grow {
  flex-grow: 1;
}
</style>
